import { useTranslation } from "react-i18next";

import { Globe } from "@/assets/icons/ds";
import { DireProgressBar } from "@/components/Layout/ProgressBar/DireProgressBar";
import { RoamingCallExplanation } from "@/components/Portal/DeviceManagement/Roaming/ShowRoamingOptions/RoamingUsage/RoamingCallExplanation";
import { TarifBarHeadline } from "@/components/Portal/DeviceManagement/Roaming/ShowRoamingOptions/RoamingUsage/TarifBarHeadline";
import { FCC } from "@/types";

interface Props {
  showRoamingCallExplanation?: boolean;
  isNotAllowedToUse?: boolean;
}

export const RoamingUnlimited: FCC<Props> = ({
  isNotAllowedToUse,
  showRoamingCallExplanation,
}) => {
  const { t } = useTranslation("portal");

  const title = t(
    "cockpit.managementTile.roaming.showOption.active.callsToAndFromAbroad",
  );

  return (
    <div className="flex w-full flex-col gap-3 rounded-md bg-surface-quaternary p-4">
      <div className="flex w-full items-center gap-3">
        <Globe className="size-6 shrink-0 text-foreground-primary" />
        <div className="flex min-w-0 flex-1 flex-col gap-4">
          {showRoamingCallExplanation ? (
            isNotAllowedToUse ? (
              <TarifBarHeadline
                title={title}
                tooltipContent={
                  <p>
                    {t(
                      "cockpit.managementTile.roaming.showOption.active.notAllowedTooltip",
                    )}
                  </p>
                }
              />
            ) : (
              <RoamingCallExplanation title={title} />
            )
          ) : (
            <TarifBarHeadline title={title} />
          )}

          <div className="flex w-full flex-col gap-2">
            <DireProgressBar value={isNotAllowedToUse ? undefined : 100} />
            <span className="text-body-sm font-semibold leading-none text-foreground-primary">
              {isNotAllowedToUse
                ? t(
                    "cockpit.managementTile.roaming.showOption.active.notAllowed",
                  )
                : t(
                    "cockpit.managementTile.roaming.showOption.active.unlimitedCalls",
                  )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
